export const FEEDBACK_SEVERITIES = ['low', 'medium', 'high', 'critical'] as const;

export type FeedbackSeverity = (typeof FEEDBACK_SEVERITIES)[number];

const FEEDBACK_SEVERITY_LABELS: Record<FeedbackSeverity, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  critical: 'Critical',
};

export function isFeedbackSeverity(value: string): value is FeedbackSeverity {
  return (FEEDBACK_SEVERITIES as readonly string[]).includes(value);
}

export function buildSeverityOptionsHtml(
  severities: readonly FeedbackSeverity[] = FEEDBACK_SEVERITIES,
  selected: FeedbackSeverity = 'medium',
): string {
  return severities
    .map((severity) => {
      const isSelected = severity === selected ? ' selected' : '';
      return `<option value="${severity}"${isSelected}>${FEEDBACK_SEVERITY_LABELS[severity]}</option>`;
    })
    .join('');
}
